module.exports = __webpack_public_path__ + "img/meditating-1.07a332db.svg";